import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { AutocompleteArrayTextInput } from '.';
import { useGetAllProfileTags } from '~/hooks/profileTags';

interface ProfileTagsFilterInputProps {
  label: string;
  className?: string;
  alwaysOn?: boolean;
}

const ProfileTagsFilterInput: React.FC<ProfileTagsFilterInputProps> = ({ label, className }) => {
  const { data: allTags, isLoading: allTagsLoading } = useGetAllProfileTags();
  const autocompleteOptions = allTags?.map((tag) => tag?.name);

  if (allTagsLoading) {
    return <Skeleton width='100%' />;
  }
  return (
    <AutocompleteArrayTextInput
      name='profileTags'
      source='profileTags'
      label={label}
      options={autocompleteOptions}
      className={className}
      disableHelperText
      freeSolo={false}
    />
  );
};

export default ProfileTagsFilterInput;
